/**
 * A mixin to publish/unpublish a Campaign, used in the CampaignDetail page.
 *
 * Dialogs must be added to the Campaigndetail page.
 *
 * Depends on:
 *   - this.campaign
 *   - this.loading
 */

import {getMainTVSpotFromBundle} from '@/utils';

var campaignPublishing = {
  data() {
    return {
      publishing: false,
      showPublishDialog: false,
      showUnpublishDialog: false,
      unpublishCampaignContentsAlso: false,
    };
  },
  computed: {
    /** Unpublished */
    numUnpublishedRadioSpots() {
      const spots = this.campaign.radio_spots.filter((spot) => !spot.published);
      return spots.length;
    },
    numUnpublishedTVSpots() {
      const spots = this.campaign.tv_spot_bundles.filter((bundle) => {
        const mainTVSpot = getMainTVSpotFromBundle(bundle);
        return !mainTVSpot.published;
      });
      return spots.length;
    },
    hasUnpublishedSpots() {
      return (
        this.numUnpublishedRadioSpots > 0 || this.numUnpublishedTVSpots > 0
      );
    },
    unpublishCampaignContentsAlsoHint() {
      return `
			  ${this.$t('campaignContentsAffected')}:
			  ${this.numPublishedRadioSpots} ${this.$t('radio')},
			  ${this.numPublishedTVSpots} ${this.$t('tv')}
			`;
    },
    /** Published */
    numPublishedRadioSpots() {
      const spots = this.campaign.radio_spots.filter((spot) => spot.published);
      return spots.length;
    },
    numPublishedTVSpots() {
      const spots = this.campaign.tv_spot_bundles.filter((bundle) => {
        const mainTVSpot = getMainTVSpotFromBundle(bundle);
        return mainTVSpot.published;
      });
      return spots.length;
    },
    hasPublishedSpots() {
      return this.numPublishedRadioSpots > 0 || this.numPublishedTVSpots > 0;
    },
  },
  methods: {
    publishCampaign(campaign) {
      const promise = this.$api.publishCampaign(campaign.id);
      promise
        .then(() => {
          this.$bus.$emit('alert-success', {
            message: 'publishedCampaign',
            translate: true,
          });
        })
        .catch((error) => {
          this.$bus.$emit('alert-error', {
            message: 'genericFailedInfo',
            translate: true,
          });
        });
      return promise;
    },
    unpublishCampaign(campaign, withContents) {
      const promise = this.$api.unpublishCampaign(campaign.id, withContents);
      promise
        .then(() => {
          this.$bus.$emit('alert-success', {
            message: 'entryUpdatedSuccess',
            translate: true,
          });
        })
        .catch((error) => {
          this.$bus.$emit('alert-error', {
            message: 'genericFailedInfo',
            translate: true,
          });
        })
        .finally(() => {
          // Reset.
          this.unpublishCampaignContentsAlso = false;
        });
      return promise;
    },
    onPublishCampaignConfirmed(callback) {
      this.publishing = true;
      this.publishCampaign(this.campaign).then(() => {
        this.publishing = false;
        this.showPublishDialog = false;

        this.loading = true;
        callback(this.campaignId).then(() => {
          this.loading = false;
        });
      });
    },
    onUnpublishCampaignConfirmed(callback) {
      this.publishing = true;
      const withContents = this.unpublishCampaignContentsAlso;
      this.unpublishCampaign(this.campaign, withContents).then(() => {
        this.publishing = false;
        this.showUnpublishDialog = false;

        this.loading = true;
        callback(this.campaignId).then(() => {
          this.loading = false;
        });
      });
    },
  },
};

export default campaignPublishing;



// WEBPACK FOOTER //
// ./src/mixins/campaignPublishing.js